export default {
  codigo: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  nome: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/product/components/search/search-form.js